var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeekAdvice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.09987 5.13333C5.24126 5.13333 6.16654 4.20805 6.16654 3.06667C6.16654 1.92528 5.24126 1 4.09987 1C2.95848 1 2.0332 1.92528 2.0332 3.06667C2.0332 4.20805 2.95848 5.13333 4.09987 5.13333Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.65 16.4998L6.16667 11.3332H7.2V9.2665C7.2 7.55442 5.81208 6.1665 4.1 6.1665C2.38792 6.1665 1 7.55442 1 9.2665V11.3332H2.03333L2.55 16.4998H5.65Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.74909 5.13333H10.2991V8.23333L13.3991 5.13333H15.9824C16.2678 5.13333 16.4991 4.90201 16.4991 4.61667V1.51667C16.4991 1.23132 16.2678 1 15.9824 1H8.74909C8.46374 1 8.23242 1.23132 8.23242 1.51667V4.61667C8.23242 4.90201 8.46374 5.13333 8.74909 5.13333Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeekAdvice);
export default __webpack_public_path__ + "static/media/SeekAdvice.056f2a02a16ebe4eda7361f072bca6c4.svg";
export { ForwardRef as ReactComponent };